export default "__VITE_ASSET__387e84f0__"